import React from "react";
import "./ComparisonSection.scss";

import FileConstants from "../../../FileConstants";
import TextConstants from "../../../TextConstants";

const { title, sub_title } = TextConstants.COMPARISON;

const ComparisonSection = () => {
  return (
    <div className="comparison-section" id="#comparison">
      <WebVersion />
      <MobileVersion />
    </div>
  );
};
const WebVersion = () => {
  return (
    <div className="d-none d-lg-block" id="web">
      <div className="section-wrapper">
        <div className="d-flex flex-column d-lg-mb-3" id="comparison-Title">
          <h1 className="manrope f-38 w-600 lh-46 white text-center comparison-title">{title}</h1>
          <p className="manrope f-16 lh-24 w-500 white text-center mb-32">
            {sub_title}
          </p>
        </div>
        <div className="comparison-table">
          <div className="comparison-column-web">
            {FileConstants.comparison[0].features.map((points, index) => (
              <div className="comparison-cell" key={index}>
                <p className="manrope f-16 w-700 lh-24 black-085 justify-space-between">{points}
                  {FileConstants.comparison[0].imgs[index] == "" ? "" :
                    <img className="benefits-icon" src={FileConstants.comparison[0].imgs[index]} />}</p>
              </div>
            ))}
          </div>
          <div className="comparison-column">
            <div className="comparison-header">
              <h2 className="manrope f-16 w-700 lh-24 white text-center mb-0">
                {FileConstants.comparison[0].header}
              </h2>
            </div>
            <div className="comparison-cell-wrapper">
              {FileConstants.comparison[0].features.map((points, index) => (
                <div
                  className="comparison-cell justify-content-center"
                  key={index}
                >
                  <img
                    className="comparison-icon"
                    src={FileConstants.comparison[0].icon}
                    alt="icon"
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="comparison-column">
            <div className="comparison-header-2">
              <h2 className="manrope f-16 w-700 lh-24 white text-center mb-0">
                {FileConstants.comparison[1].header}
              </h2>
            </div>
            <div className="comparison-cell-wrapper second">
              {FileConstants.comparison[1].features.map((points, index) => (
                <div className="comparison-cell" key={index}>
                  <img
                    className="comparison-icon mr-2"
                    src={FileConstants.comparison[1].icon}
                    alt="icon"
                  />
                  <p className="manrope f-14 w-500 lh-22 black-085">{points}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const MobileVersion = () => {
  return (
    <div className="d-lg-none" id="mobile">
      <div className="section-wrapper">
        <div className="d-flex flex-column">
          <h1 className="manrope f-30 w-600 lh-40 white text-center mb-16">{title}</h1>
          <p className="manrope f-16 w-500 lh-24 white text-center">
            {sub_title}
          </p>
        </div>
        <div className="comparison-table">
          <div className="comparison-column">
            <div className="comparison-header">
              <h2 className="manrope f-16 w-700 lh-24 white text-center mb-0">
                {FileConstants.comparison_mobile[0].header}
              </h2>
            </div>
            <div className="comparison-cell-wrapper first">
              {FileConstants.comparison_mobile[0].features.map((points, index) => (
                <div className="comparison-cell" key={index}>
                  <img
                    className="comparison-icon mb-2"
                    src={FileConstants.comparison_mobile[0].icon}
                    alt="icon"
                  />
                  <p className="manrope f-14 w-500 lh-22 black-085 text-center">
                    {points}
                    {FileConstants.comparison_mobile[0].imgs[index] == "" ? "" :
                      <img className="benefits-icon mt-8" src={FileConstants.comparison_mobile[0].imgs[index]} />}
                  </p>

                </div>
              ))}
            </div>
          </div>
          <div className="comparison-column">
            <div className="comparison-header-2">
              <h2 className="manrope f-16 w-700 lh-24 white text-center mb-0">
                {FileConstants.comparison_mobile[1].header}
              </h2>
            </div>
            <div className="comparison-cell-wrapper second">
              {FileConstants.comparison_mobile[1].features.map((points, index) => (
                <div className="comparison-cell" key={index}>
                  <img
                    className="comparison-icon mb-2"
                    src={FileConstants.comparison_mobile[1].icon}
                    alt="icon"
                  />
                  <p className="manrope f-14 w-500 lh-22 black-085 text-center">
                    {points}
                  </p>

                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ComparisonSection;
